import { User } from "@src/interfaces/user.interface";
import { ApiResponse } from "@shared/lib/interfaces/types";

export interface Brand {
    id: string;
    name: string;
    alias?: string;
}

export interface Model {
    id: string;
    name: string;
    alias?: string;
}

export interface Generation {
    id: string;
    name: string;
    generation?: number;
    restyleNumber?: number;
    startedAt?: number;
    endedAt?: number;
}

export interface SendCallbackArgs {
    name: string;
    phoneNumber: string;
    email: string;
    message: string;
}

export interface AddToFavoritesBulkArgs {
    offerUuids: string[];
}

export interface ElasticSearchResponse<T> {
    data: T;
    meta: {
        total: number;
        totalPage: number;
        draftTotal?: number | null;
        onVerificationTotal?: number | null;
        activeTotal?: number | null;
        declinedTotal?: number | null;
        archiveTotal?: number | null;
    };
    code: number;
    message: string;
    traces: string[];
}

export interface AuthState {
    isPersonal?: boolean | null;
    currentUser: User | null;
    accessToken?: string;
    authState: boolean;
    isLoggingIn: boolean;
    isRegistering: boolean;
    errorMessage: string | null;
    routeToOpen?: string;
    emailMemory?: string;
    phoneMemory?: string;
}

export interface LoginResponse {
    message?: string;
    data: {
        accessToken?: string;
        refreshToken: string;
    };
    user?: User;
}

export const optionsTags = [
    "BRANDS_OPTIONS",
    "MODELS_OPTIONS",
    "CITY_OPTIONS",
    "BODY_TYPES_OPTIONS",
    "TRANSMISSION_OPTIONS",
    "ENGINE_OPTIONS",
    "DRIVE_TYPES_OPTIONS",
    "GENERATION_OPTIONS",
    "DISPLACEMENTS_OPTIONS",
    "WHEELS_OPTIONS",
    "SELLER_OPTIONS"
];

export type QueryParams = {
    brandUuid?: string;
    modelUuid?: string;
    generationUuid?: string;
};

export interface ElasticHit<T> {
    _source: T;
}

export interface ElasticResponse<T> {
    data: {
        hits: {
            hits: ElasticHit<T>[];
        };
    };
}

export interface BrandSource {
    id: string;
    name: string;
    alias: string;
}

export interface ModelSource {
    id: string;
    name: string;
    alias: string;
}

export interface CitySource {
    name: string;
    alias: string;
}

export interface GenerationSource {
    id: string;
    name: string;
    generation: number;
    restyle_number: number;
    started_at: number;
    ended_at: number;
}

export interface SellerTypeSource {
    seller_type: string;
}

export interface OptionsResponse {
    data: {
        options: Array<{ name: string }>;
    };
}

export interface DisplacementOption {
    name: number;
}

export interface DisplacementsResponse {
    data: {
        options: DisplacementOption[];
    };
}

export interface BrandsQueryArgs {}

export interface ModelsQueryArgs {
    brandUuid: string;
}

export interface CityQueryArgs {
    cityName: string;
    exact?: boolean;
}

export interface GenerationsQueryArgs {
    model_uuid: string;
}

export interface SellerTypesQueryArgs {
    brand?: string;
    model?: string;
}

export interface CityOption {
    name: string;
    alias: string;
}

export interface UploadImagesOfferRequest {
    formData: FormData;
}

export interface UploadImagesOfferResponse {
    big: string;
    small: string;
}

export interface UploadImagesOfferApiResponse extends ApiResponse<UploadImagesOfferResponse> {}